import { VARIATION_DIALOG_MESSAGES, VariationDialogMessages } from "./variations-dialog.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type VariationsTableMessages = VariationDialogMessages &
  PopoverMessages &
  TableColumnsMessages & {
    descriptionColumn: string;
    optionsColumn: string;
  };

export const VARIATIONS_TABLE_MESSAGES: VariationsTableMessages = {
  descriptionColumn: "Nome",

  ...TABLE_COLUMNS_MESSAGES,
  ...VARIATION_DIALOG_MESSAGES,
  ...POPOVER_MESSAGES,
};

export default VARIATIONS_TABLE_MESSAGES;
